import React, { useEffect, useState } from 'react';
import styles from './styles.module.scss';
import { getQuizList } from '../../services/api-auto';
import ModalLoading from '../../components/ModalLoading';
import QuizCard from '../../components/QuizCard';
import { useHistory } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { useGetUser } from '../../hooks/useGetUser';

const Quiz = () => {

    const history = useHistory();
    const [quiz, setQuizzes] = useState([])
    const [verMais, setVerMais] = useState(true)
    const [modalLoading, setModalLoading] = useState(false);
    const [filter, setFilter] = useState( {page : 1, pageSize: 10, query: "" } );
    const [buscar, setBuscar] = useState('')

    const getQuiz = async() => {
        setModalLoading(true)
        const data = await getQuizList(filter);
        setModalLoading(false)
        setQuizzes(data.data)
    } 

    useEffect(()=> {
        (quiz && quiz.items?.length > 0 && quiz.page === quiz.totalPages ) ? setVerMais(true) : setVerMais(false); 
        getQuiz()
    },[])

    const addPage = async () => {
        setModalLoading(true)
        const data = await getQuizList(filter);
        setModalLoading(false)
        const f = filter;
        f.page += 1;
        setFilter(f);
        getQuiz([...quiz, ...data.data])
    }

    const findAcoes = async () => {
        const f = filter;
        f.query = buscar;
        f.page = 1;
        setFilter(f);
        const quiz = await getQuizList(filter);
        setQuizzes(quiz.data);
    }

    const user = useGetUser();

    return (
        <>
        {( user.perfilAcesso === 'Master' ) && (
            <>
                <div className={styles.wrapper}>
                    <div className={styles.title}>
                        Quizzes
                    </div>
                    <div className={styles.buttonWrapper}>
                        <button className={`btnInvert ${styles.btAdd}`} onClick={() => {history.push('/quiz/detalhe')}}>
                            Cadastrar quiz
                        </button>
                    </div>
                    <div className={styles.subTitle}>
                        Quizzes cadastrados
                    </div>
                    <div className={styles.buscar}>
                        <FormControl>
                            <TextField  type="text"  size="small"
                                onChange={(e) => {setBuscar(e.target.value)}}
                                label="Faça sua busca"
                                value={buscar}
                                variant="filled"
                                className="customFilledInput"
                                onKeyDown= {
                                    (e) => {
                                        if (e.key === 'Enter') {
                                            findAcoes();
                                            e.preventDefault();
                                        }
                                    }
                                }
                                InputProps={{endAdornment: (
                                    <button onClick={findAcoes} className={styles.searcButton}>
                                        <FontAwesomeIcon icon={faSearch}/>
                                    </button>
                                )}}
                            />
                        </FormControl>
                    </div>
                    <div className={styles.acoesWrapper}>
                        {quiz && quiz.items?.map(
                            (q) => <QuizCard quiz={q}/>
                        )}
                    </div>
                    {
                        quiz.items?.length === 0 &&
                        <div className={styles.verMaisWrapper}> Não existem dados para exibir </div>
                    }
                    { verMais && (
                        <div className={styles.verMaisWrapper}>
                            <button className={`customButton ${styles.verMaisButton}`} onClick={addPage} >
                                Ver mais
                            </button>
                        </div>
                    )}
                    <ModalLoading
                        open={modalLoading} 
                        size="lg"
                    />
                </div>
            </>
        )}

        </>
    );
  
}

export default Quiz;